import { render } from "./GroupForm.vue?vue&type=template&id=49ce75da&scoped=true&ts=true"
import script from "./GroupForm.vue?vue&type=script&lang=ts"
export * from "./GroupForm.vue?vue&type=script&lang=ts"

import "./GroupForm.vue?vue&type=style&index=0&id=49ce75da&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ce75da"]])

export default __exports__